import React, { useState, useEffect } from "react"
import '../sass/App.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faIdCard } from '@fortawesome/free-regular-svg-icons'
import { faBriefcase, faRocket, faUserCircle, faEnvelope, faLaptopCode, faRobot, faVolleyballBall } from '@fortawesome/free-solid-svg-icons'
import { faPlaystation, faReact, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { graphql } from "gatsby"

export default function Home({ data }) {

  const [section, setSection] = useState("profile");
  const [language, setLaguage] = useState("en");
  const [dataResult, setDataResult] = useState({})

  // define dimension variables for use in hook
  let height;
  let width;

  if (typeof window !== `undefined`) {
    height = window.innerHeight
    width = window.innerWidth
  }


  const [widthH, setWidthH] = useState(width);
  function handleWindowSizeChange() {
    setWidthH(width);
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    }
  }, []);



  useEffect(() => {

    //set
    setTimeout(() => setDataResult(data.allLanguage.nodes.filter(item => item.id == language)[0]), 1000);


  }, [language]);

  let isMobile = true;

  if (typeof window != "undefined") isMobile = width <= 768;

  return (typeof dataResult.data == 'object') ? (<main>
    <div className="columns is-mobile ml-0 mr-0">
      <div className={`tile column ${isMobile ? "is-10" : "is-12"} p-0`}>
        <div className="tile p-5">
          <div className="tile is-parent is-vertical">
            <article className="tile is-child  has-text-centered">

              <p className="title has-text-black">Full Stack Developer</p>

              <p>
                <div class="buttons has-addons is-clearfix">
                  <button class={`button is-small ${language == 'en' ? 'is-danger is-selected' : ''}`} onClick={() => setLaguage('en')}>ENG</button>
                  <button class={`button is-small ${language == 'es' ? 'is-danger is-selected' : ''}`} onClick={() => setLaguage('es')}>ESP</button>
                </div>
              </p>

              <p>
                <ul class="ch-grid">
                  <li>
                    <div class="ch-item ch-img-1">
                      <div class="ch-info">
                        <h3>
                          <img src="./images/ninja.png" style={{ "width": "70px" }} />
                        </h3>
                        <p>by Boris Benalcazar{/* <a href="http://drbl.in/eOPF">View on Dribbble</a> */}</p>
                      </div>
                    </div>
                  </li>

                </ul>
              </p>

              <p><FontAwesomeIcon icon={faUserCircle} />&nbsp;&nbsp;Boris Benalcázar</p>
              <p><FontAwesomeIcon icon={faEnvelope} />&nbsp;&nbsp;boris_90@hotmail.es</p>
              <p onClick={() => window.open("https://www.linkedin.com/in/bbenalcazar/", "_blank")}><FontAwesomeIcon icon={faLinkedin} />&nbsp;&nbsp;bbenalcazar</p>



              {(section == 'profile' || !isMobile) ? (
                <>
                  <article className="tile is-child pt-5">
                    <p className="title has-text-black has-text-primary has-text-justified">{dataResult.data.profile}</p>
                    <p className="has-text-justified">{dataResult.data.description}</p>
                    {/* <figure className="image is-4by3">
                            <img src="https://bulma.io/images/placeholders/640x480.png" />
                          </figure> */}
                  </article>

                  <article className="tile is-child pt-5 has-text-justified">
                    <p className="title has-text-black has-text-primary ">{dataResult.data.education}</p>

                    {
                      dataResult.data.educationlist.map(item => (
                        <>
                          <p className="Subtitle has-text-weight-bold pt-3">{item.name}</p>
                          <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                        </>
                      ))
                    }


                    {/* <figure className="image is-4by3">
                            <img src="https://bulma.io/images/placeholders/640x480.png" />
                          </figure> */}
                  </article>


                </>) : ''
              }

            </article>
          </div>

          {
            (section == 'expirence' || !isMobile) ? (
              <div className="tile is-parent is-vertical">
                <article className="tile is-child">
                  <p className="title has-text-black has-text-primary">{dataResult.data.expirence}</p>

                  {
                    dataResult.data.ecpirencelist.map(item => (

                      <p className="pt-4">
                        <p className="subtitle"><b dangerouslySetInnerHTML={{ __html: item.name }}></b></p>
                        <article class="message">
                          <div class="message-body has-text-justified">
                            {
                              item.list.map(item_1 => <li>{item_1.description}</li>)
                            }

                          </div>
                        </article>
                      </p>

                    ))
                  }
                </article>
              </div>
            ) : ''

          }

          {
            (section == 'skills' || !isMobile) ? (
              <div className="tile is-parent is-vertical">

                <article className="tile is-child">
                  <p className="title has-text-black has-text-primary">{dataResult.data.skills}</p>

                  {
                    dataResult.data.skillslist.map(item => (
                      <>
                        <div class="has-text-justified is-size-6 pt-3">
                          {item.description}
                        </div>
                        <div class="has-text-justified is-size-6 pt-2">
                          <progress class="progress is-danger is-medium" value={item.porcentage} max="100">100%</progress>
                        </div>
                      </>
                    ))
                  }

                </article>

              </div>
            ) : ''
          }

          {
            (section == 'courses' || !isMobile) ? (
              <div className="tile is-parent is-vertical" id="profile">
                <article className="tile is-child">
                  <p className="title has-text-black has-text-primary">{dataResult.data.courses}</p>

                  {
                    dataResult.data.coourseslist.map(item => (
                      <>
                        <p className="Subtitle has-text-weight-bold pt-3">{item.name}</p>
                        <p dangerouslySetInnerHTML={{ __html: item.description }}></p>
                      </>
                    ))
                  }

                </article>

                <article className="tile is-child">
                  <p className="title has-text-black has-text-primary">{dataResult.data.interest}</p>

                  {
                    dataResult.data.interestslist.map(item =>
                      <p>
                        {
                          item.icon == 'faRobot' ? <FontAwesomeIcon icon={faRobot} /> :
                            item.icon == 'faPlaystation' ? <FontAwesomeIcon icon={faPlaystation} /> :
                              item.icon == 'faVolleyballBall' ? <FontAwesomeIcon icon={faVolleyballBall} /> : ''
                        }
                              &nbsp;
                                {item.name}
                      </p>
                    )
                  }
                </article>
              </div>
            ) : ''
          }


        </div>

      </div>

      {
        isMobile ? (
          <div className="column is-2 notification is-primary pt-5 mt-2 " id="top-menu">

            <div className={`tile columns is-12 tab ${section == 'profile' ? "tab-active" : ""}`} href="#profile">
              <div className="tile column has-text-centered">
                <FontAwesomeIcon onClick={() => setSection('profile')} icon={faIdCard} />
              </div>
            </div>

            <div className={`tile columns is-12 tab ${section == 'expirence' ? "tab-active" : ""}`} href="#skills">
              <div className="tile column has-text-centered">
                <FontAwesomeIcon onClick={() => setSection('expirence')} icon={faBriefcase} />
              </div>
            </div>

            <div className={`tile columns is-12 tab ${section == 'skills' ? "tab-active" : ""}`}>
              <div className="tile column tab has-text-centered">
                <FontAwesomeIcon onClick={() => setSection('skills')} icon={faRocket} />
              </div>
            </div>

            <div className={`tile columns is-12 tab ${section == 'courses' ? "tab-active" : ""}`}>
              <div className="tile column tab has-text-centered">
                <FontAwesomeIcon onClick={() => setSection('courses')} icon={faLaptopCode} />
              </div>
            </div>



          </div>
        ) : ''
      }


    </div>
  </main>) : (<div class="pageloader is-right-to-left is-active"><span class="title">Loading...</span></div>)
}

export const query = graphql`
  query {
    allLanguage {
      totalCount
    nodes{
      name
      id
      data {
        courses
        coourseslist {
          id
          name
          description
        }
        interest
        interestslist {
          id
          icon
          name
        }
        profile
        description
        education
        educationlist {
          id
          name
          description
        }
        expirence
        ecpirencelist {
          id
          name
          list {
            id
            description
          }
        }
        skills
        skillslist {
          id
          description
          porcentage
        }
      
      }
    }
      
    }
  }
`
